import type { LandingDict } from './en';

const zh: LandingDict = {
  nav: { chat: 'Chat Apps', agentic: 'Agentic Apps', build: "创建应用", org: "My Org", pricing: '价格', privacy: "隐私", contact: "联系我们", language: '语言' },
  hero: {
    titlePre: '你的',
    titleMark: '本地 AI',
    titlePost: '\n工作站。',
    sub: "把专业知识、表格和会议，变成答案、图表和 PPT。数据不离开你的 Mac。",
    watch: "观看 2 分钟宣传片",
    pill: "最新版本",
    chip: "Wi‑Fi 已关闭 · 0 字节外发",
    badges: { offline: "可离线使用", server: "你的服务器，不是我们的", free: "免费开始" },
    reqs: '需要 Apple 芯片 Mac · 最低 16GB 内存 · 32GB+ 可运行更强的推荐模型',
  },
  stats: {
    free: '免费',
    freeSub: '全部 Chat Apps、模型下载与软件更新，永久免费',
    chatApps: 'Chat Apps',
    agenticApps: 'Agentic Apps',
    bytesSub: '在本机运行 AI 时，发送到云端的数据量',
    langsSub: '种界面语言，中文、English、日本語……',
  },
  film: { kicker: '宣传片', title: '看看 Estha 怎么工作。', watchOnYouTube: '在 YouTube 上观看', trouble: '无法播放？到 YouTube 观看 ↗' },
  overview: {
    kicker: '一个应用，四种用法',
    title: '从对话，到智能体，\n再到全组织共用的应用。',
    explore: '了解',
    chat: { title: 'Chat Apps', desc: '内置专业知识库的 AI 专家——教科书、方法论、行业领域知识。', tag: '永久免费' },
    agentic: { title: 'Agentic Apps', desc: '端到端处理复杂任务的 AI 智能体。', tag: '{n} 款，持续增加' },
    build: { title: "创建应用", desc: '用 Quick Bot 把自己的资料变成 Chat App，或在 Playground 画布上自由编排。', tag: 'Quick Bot · Playground' },
    org: { title: 'My Org', desc: '组织专属的品牌化应用空间，应用经过审核，访问权限可控。', tag: '企业版' },
  },
  chat: {
    kicker: 'Chat Apps',
    title: '有真材实料的 AI 专家。',
    freePill: '永久免费',
    lede: '每个 Chat App 都自带知识库，直接在你的 Mac 上建立索引。',
    feats: {
      kb: { title: '本地知识库', desc: '安装应用时在本机建立知识库，回答有据可依。' },
      files: { title: '带上你自己的文件', desc: '可附加图片、PDF、DOCX、TXT、MD，长文档自动启用智能检索。' },
      browse: { title: '浏览、置顶、收藏', desc: '按测评、职业、沟通、教育等分类浏览；新应用有 NEW 标记；⌘K 搜索一切。' },
    },
  },
  agentic: {
    kicker: 'Agentic Apps',
    title: '{n} 款智能体应用，\n还在持续增加。',
    lede: '从一张表格、一份 PDF、一段录音或一个想法，到成型的图表、幻灯片、文档或原型——全在你的 Mac 上私密完成。',
    seeThem: '看看它们的真实界面',
  },
  build: {
    kicker: '创建应用',
    title: '在你的 Mac 上，\n做一个你自己的 Chat App。',
    lede: '把你自己的资料变成 Chat App——本地建索引，满意了再发布。',
    quick: {
      badge: '推荐',
      desc: '上传知识库、写一段系统提示词，即可发布。适合把资料快速变成问答 Bot。',
      items: ['单页表单，几步完成', '知识库问答开箱即用', '内置提示词模板启发'],
    },
    advanced: {
      title: '高级开发 · Playground',
      desc: '可视化节点编辑器，自由组合多节点、分支、AB 测试与关键词路由。',
      items: ['节点画布', '多节点 / 分支 / AB 测试', '精细字段与调试'],
    },
    guideTitle: '本地 AI 搭建向导全程陪着你。',
    guideText: '告诉它你想让应用做什么，它会告诉你该拖哪些节点、怎么连。创建应用包含在高级版中。',
  },
  private: {
    kicker: '隐私优先',
    title: "数据不上云。\n工作不被追踪。",
    lede: "AI 在哪里运行由你决定。Estha 默认为每个功能自动选择合适的模型，你也可以随时在应用内手动切换。",
    boundary: "数据边界 = 你的网络",
    local: { title: '在这台 Mac 上', desc: '完全离线，数据不离开这台电脑。使用本机内存运行模型。', best: '适合内存充足的 Mac' },
    server: { title: '在我的 Estha Server 上', desc: '把重活交给局域网里一台更强的 Mac，让这台 Mac 保持轻快。', best: '适合笔记本和内存有限的 Mac' },
    cluster: { desc: '连接到 Mac Studio 集群，在数据留在内网的前提下卸载高负载推理。', best: '自动发现局域网内的 Estha Studio Master 节点' },
    models: {
      every: '所有支持的 Mac 都能跑',
      whisper: "Whisper 语音转写",
      recommended: '推荐模型',
      larger: "更大的 Qwen 与 Gemma 模型",
      vision: "支持图像理解的视觉模型",
      open: '开源模型，为 Apple 芯片优化',
      openItems: ['应用内下载、切换模型', '专用代码与向量模型', '模型下载永久免费'],
    },
  },
  org: {
    kicker: 'My Org',
    title: '组织专属的 AI 应用空间。',
    lede: 'Estha 里一个带你们品牌的专属版块，放着组织审核过的应用。',
    signIn: '登录 My Org Admin',
    talk: '联系 Estha 团队',
    feats: {
      review: { title: '发布前审核', desc: '每一次新建、更新或下架都要经过管理员审核；驳回时必须附上审核意见。' },
      access: { title: '按群组或个人授权', desc: '精确决定每个应用谁能看到——按部门、团队或个人。' },
      brand: { title: '你的品牌，进入应用', desc: '组织名称、欢迎语、Logo、横幅和主题色，上线前可预览效果。' },
    },
  },
  pricing: {
    kicker: '会员',
    title: '免费开始，\n需要时再解锁全部。',
    free: { name: '免费版', sub: '永久免费。', items: ["全部 Chat Apps", '文档处理永久免费', '模型下载、软件和更新——永久免费'] },
    premium: {
      name: '高级版', flag: '14 天免费试用', firstYear: '首年',
      sub: '之后每年 30 美元。验证邮箱即可先免费试用 14 天。',
      items: ['包含免费版全部权限', '解锁全部当前及未来 Agentic Apps', 'Chatbot 构建器——本地创建、编辑、预览、保存并发布 chatbot'],
      cta: '在应用内开始试用',
    },
    enterprise: {
      name: '企业版', price: '联系我们', sub: '面向在团队中部署 Estha 的组织。',
      items: ['包含高级版全部权限', '为团队定制专属 Chat Apps 与 Agentic Apps', 'Estha Server 应用能力', 'My Org 应用空间与 My Org Admin'],
    },
  },
  faq: {
    title: '下载之前，\n你可能想知道。',
    spec: { chip: '芯片', memory: '内存', memMin: '最低 16GB', memRec: '32GB+ 可运行推荐模型', languages: '语言', langsVal: '13 种界面语言', version: '最新版本' },
    qa: [
      { q: '会有数据离开我的 Mac 吗？', a: '选择"在这台 Mac 上"运行时完全离线，数据不离开这台电脑。如果选择 Estha Server 或 Mac Studio 集群，数据只会发送到你自己局域网里的那台机器。' },
      { q: "哪些操作需要联网？", a: "只有少数几项：登录、高级版试用时的邮箱验证、下载模型、检查更新，以及不定期验证会员状态。你的提示词、文件和结果永远不会被上传——模型下载完成后，AI 功能可完全离线使用。" },
      { q: "Estha 的服务器能看到什么？", a: "只有维持你账户运作所需的信息：登录信息、会员状态、用于检查更新的应用版本，以及你在商店里浏览的应用。你的对话、文件、会议，以及你在 Estha for Mac 中创建的应用，都只留在你的 Mac 上——我们从不接收。你的组织通过 My Org 发布的应用会存储在我们的服务器上，以便分发到成员的 Mac。" },
      { q: "Estha 会保留我的数据，或用它训练 AI 吗？", a: "不会。你的提示词和文件都在你的 Mac 上处理，从不会传到我们这里，所以我们没有任何数据可以保留或用来训练。你下载的开源模型也从不会用你的数据训练。聊天记录只保存在你的 Mac 上，你可以随时删除。" },
      { q: "我的数据存储在哪里？", a: "存储在你自己的 macOS 用户账户中，路径为 ~/Library/Application Support/Estha。同一台 Mac 上的其他用户无法打开。我们建议开启 FileVault，这样万一 Mac 丢失，数据也是加密的。你的密码从不会保存在你的 Mac 上。" },
      { q: '哪些免费，哪些需要高级版？', a: '全部 Chat Apps、文档处理、模型下载和更新都免费。高级版解锁全部当前及未来的 Agentic Apps 和 Chat App 构建器，并可先免费试用 14 天。' },
      { q: "有用量限制或积分吗？", a: "没有。没有积分，不用购买 token，也没有每日限额。AI 在你自己的 Mac 上运行，能用多少只取决于它的内存和芯片。" },
      { q: '用的是哪些 AI 模型？', a: 'Qwen、Gemma 等领先的开源模型，以及用于语音转写的 Whisper，通过 Apple 的 MLX 引擎运行。模型在应用内下载和切换。' },
      { q: "内置了哪些安全防护？", a: "你上传的文档只会被当作信息，绝不会被当作给 AI 的指令。PDF 阅读助手会为每个回答标出所依据的原文段落，文档里没有答案时也会直接告诉你。“数据分析”编写的代码在受限沙箱中运行，Vibe Coding 的预览无法连接互联网。Estha 已通过 Apple 签名与公证。" },
      { q: '我可以自己做应用吗？', a: '可以。用 Quick Bot 几步就能把最多 3 个文件变成带知识库的 Chat App；也可以用 Playground 节点画布做分支、AB 测试和出题。本地搭建向导会一路帮你。' },
      { q: '组织如何统一部署？', a: '企业版中，管理员在 My Org Admin 管理用户与群组、审核每一个应用，成员会在 Estha 里看到品牌化的 My Org 空间。请联系 {email}。' },
    ],
  },
  final: { title: '准备好在本地运行 AI 了吗？', reqs: '支持所有 Apple 芯片 Mac · 最低 16GB 内存' },
  footer: {
    tagline: '你的本地 AI 工作站——本地运行、MLX 驱动、隐私优先。',
    product: '产品', createApp: '创建应用', pricing: '价格',
    orgs: "My Org", signIn: '登录 My Org Admin',
    security: "安全", changelog: "更新日志", docs: "文档", support: "支持",
    company: '公司', privacy: '隐私政策', terms: '使用条款',
    rights: '© 2026 Estha. 保留所有权利。',
  },
  proof: { press: "媒体报道", voices: "团队怎么说" },
  contact: {
    title: "给 Estha 团队发邮件", copy: "复制邮箱地址", copied: "已复制",
    gmail: "用 Gmail 写信", mailApp: "用邮件 App 打开",
    subject: "Estha for Mac 咨询",
  },
  share: {
    button: "分享", title: "分享 Estha",
    sub: "选一张卡片发出去，或者直接发链接。",
    style: "卡片", size: "尺寸",
    templates: { hero: "Estha", agentic: "Agentic Apps", private: "隐私" },
    landscape: "横版", portrait: "竖版",
    shareImage: "分享图片…", download: "下载图片", copyImage: "复制图片", copied: "已复制",
    copyLink: "复制链接", link: "链接", postTo: "分享到",
    email: "邮件",
    text: "Estha 把开源 AI 模型完整运行在你的 Mac 上——私密、可离线、免费下载。",
    cardCta: "免费下载 · 适用于 Apple 芯片 Mac",
    close: "关闭",
  },
  apps: {
    dataAnalyst: { name: '数据分析', description: '上传 CSV/Excel 文件，用自然语言提问。自动生成图表、统计分析和数据洞察——所有处理均在本地 Mac 上完成。', tags: ['CSV / Excel', '自动图表', '自然语言查询', 'EN / 中文'] },
    pptMaker: { name: 'PPT 制作', description: '描述你的演示主题，即可获得专业结构的 PowerPoint 演示文稿。多步骤 AI 流水线自动生成大纲、逐页内容和精美的 .pptx 文件。', tags: ['.pptx 输出', '自动排版', '多步骤流水线'] },
    pdfReader: { name: 'PDF 阅读助手', description: '打开 PDF 即可对话提问。每个回答都基于文档原文，附可点击引用，一键跳转到出处段落——全程在你的 Mac 本地处理。', tags: ['PDF 问答', '可验证引用', '划词提问', '100% 本地'] },
    documentProcessing: { name: '文档处理', description: '你的全能文档专家。从零撰写博客、社交媒体文案、法律条款和商务文档。编辑和优化现有文件，跨语言翻译，审查内容质量——完全在 Mac 本地私密运行。', tags: ['撰写起草', '编辑优化', '翻译', '审阅审计'] },
    meetingIntelligence: { name: '会议智能', description: '用 AI 录制、转录和分析会议。自动生成会议纪要、行动项和关键决策——完全私密，音频绝不离开你的设备。', tags: ['语音转录', '会议纪要', '行动项', '100% 私密'] },
    vibeCoding: { name: 'Vibe Coding：原型', description: '用 AI 生成可交互的界面预览。用自然语言描述界面，获得可点击的原型，并持续迭代。最终输出单个自包含的 .html 文件，全程在你的 Mac 本地生成。', tags: ['单个 .html 文件', '可交互预览', '点选编辑', '100% 本地'] },
    translate: { name: "翻译", description: "翻译文本以及 Word、纯文本或 Markdown 文档，共用一个术语库保证用词一致 —— 全程在你的 Mac 本地处理。", tags: ["文本与文档", ".docx / .txt / .md", "术语库", "100% 本地"] },
  },
  screens: {
    chat: [
      { label: '浏览商店', caption: '浏览、安装、置顶——永久免费' },
      { label: '安装', caption: '安装时在本机建立知识库' },
      { label: '对话', caption: '依据知识库作答' },
    ],
    build: [
      { label: '创建应用', caption: 'Quick Bot 或高级开发，都能对话' },
      { label: 'Quick Bot', caption: '上传知识库、写提示词、发布' },
      { label: 'Playground', caption: '节点、分支与知识，可视化编排' },
      { label: '已发布', caption: '已发布，可以对话' },
    ],
    analyst: [
      { label: '提出问题', caption: '用自然语言问数据' },
      { label: '分析中', caption: '在你的 Mac 上分析' },
      { label: '图表与结论', caption: '答案、图表和分析过程' },
    ],
    ppt: [
      { label: '设置', caption: '主题、页数、语言、语气、风格' },
      { label: '审阅大纲', caption: '生成前先审阅、修改大纲' },
      { label: '预览成品', caption: '成型、可编辑的 .pptx，本机生成' },
    ],
    pdf: [
      { label: '打开 PDF', caption: '论文、报告、手册、扫描件' },
      { label: '阅读中', caption: '在本机逐页阅读' },
      { label: '带出处的回答', caption: '每个回答都指向原文条款' },
    ],
    doc: [
      { label: '选中段落', caption: '选中文字，说出你的要求' },
      { label: '改写中', caption: '直接在文档里改写' },
      { label: '接受或拒绝', caption: '改写、润色、翻译，逐条接受或拒绝' },
    ],
    meeting: [
      { label: '录音', caption: '本机实时转写' },
      { label: '选择输出', caption: '选择要生成的内容' },
      { label: '摘要', caption: '决策与行动项，自动写好' },
      { label: '行动项', caption: '负责人与时间，附原文依据' },
    ],
    vibe: [
      { label: '描述需求', caption: '用自然语言描述界面' },
      { label: '生成中', caption: '全程在这台 Mac 上生成' },
      { label: '原型', caption: '可点击、有版本，单个 .html 文件' },
      { label: '点选编辑', caption: '选中任意区域，说出要改什么' },
    ],
    translate: [
      { label: "翻译文本", caption: "紫色词语来自你的术语库" },
      { label: "翻译文档", caption: ".docx、.txt 或 .md —— 原文件保持不变" },
      { label: "术语库", caption: "术语库让每个用词都保持一致" },
    ],
    private: [
      { label: '在这台 Mac 上', caption: '完全离线，数据不离开这台电脑' },
      { label: 'Mac Studio 集群', caption: '更大的模型，留在内网' },
    ],
    org: [
      { label: '组织应用空间', caption: '品牌化空间，团队专属应用' },
      { label: '企业版权限', caption: '成员只能打开组织授予的应用' },
    ],
  },
};

export default zh;
